/* Sequential Racing custom sections */
(function () {
  if (window.SRSections) return;
  document.documentElement.classList.add('sr-js');
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function store(k, v) {
    try {
      if (v === undefined) return window.localStorage.getItem(k);
      window.localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function restart(el, cls) { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sr-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      var span = document.createElement('span');
      var link = document.createElement('a');
      link.href = ROOT + 'cart';
      link.textContent = 'View cart';
      toastEl.appendChild(span);
      toastEl.appendChild(link);
      document.body.appendChild(toastEl);
    }
    toastEl.firstChild.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4000);
  }

  function updateCount() {
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        each(document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span'), function (el) {
          if (!el.children.length) el.textContent = cart.item_count;
        });
      }).catch(function () {});
  }

  /* The theme's own add-to-cart feedback: its cart drawer or its cart notification, whichever the theme is set to use. */
  function cartTarget() {
    var mode = window.theme && window.theme.settings && window.theme.settings.cartDrawer && window.theme.settings.cartDrawer.atcAction;
    var drawer = document.querySelector('cart-drawer');
    var note = document.querySelector('cart-notification');
    var list = mode === 'drawer' ? [drawer, note] : [note, drawer];
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el && typeof el.renderContents === 'function' && typeof el.getSectionsToRender === 'function') return el;
    }
    return null;
  }

  function addToCart(btn) {
    if (btn.disabled) return;
    var original = btn.innerHTML;
    var target = cartTarget();
    var payload = { id: Number(btn.getAttribute('data-sr-add')), quantity: 1 };
    if (target) {
      try {
        payload.sections = target.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = window.location.pathname;
      } catch (e) { target = null; }
    }
    btn.disabled = true;
    btn.textContent = 'Adding';
    if (!RM) restart(btn, 'sr-rev');
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'Could not add to cart');
        return j;
      });
    }).then(function (json) {
      btn.classList.add('is-done');
      btn.textContent = 'Added';
      var shown = false;
      if (target && json.sections) {
        try { target.renderContents(json); shown = true; } catch (e) { shown = false; }
      }
      if (!shown) {
        toast((btn.getAttribute('data-title') || 'Item') + ' added to cart');
        updateCount();
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = original; btn.disabled = false; }, 2400);
    }).catch(function (err) {
      btn.innerHTML = original;
      btn.disabled = false;
      toast(err.message || 'Could not add to cart');
    });
  }

  /* ---------- garage ---------- */
  function initGarage(root) {
    if (root.__srInit) return;
    root.__srInit = true;
    var tabs = root.querySelectorAll('[data-sr-tab]');
    var stages = root.querySelectorAll('[data-sr-stage]');
    var panels = root.querySelectorAll('[data-sr-panel]');
    var tablist = root.querySelector('[role=tablist]');
    if (!tabs.length) return;
    var cur = -1, timer = null, playing = false;
    var dur = (parseInt(root.getAttribute('data-interval'), 10) || 6) * 1000;
    root.style.setProperty('--sr-dur', dur / 1000 + 's');

    function centerTab(i) {
      if (!tablist || tablist.scrollWidth <= tablist.clientWidth) return;
      var t = tabs[i];
      var left = t.offsetLeft - (tablist.clientWidth - t.clientWidth) / 2;
      try { tablist.scrollTo({ left: left, behavior: RM ? 'auto' : 'smooth' }); } catch (e) { tablist.scrollLeft = left; }
    }

    function show(i, opts) {
      opts = opts || {};
      if (i === cur) return;
      var prev = cur;
      cur = i;
      each(tabs, function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      each(stages, function (s, k) {
        var on = k === i;
        s.hidden = !on;
        if (on) restart(s, 'is-active'); else s.classList.remove('is-active');
      });
      var oldP = prev >= 0 ? panels[prev] : null;
      var newP = panels[i];
      function swap() {
        each(panels, function (p, k) { p.hidden = k !== i; });
        if (!RM && newP) each(newP.querySelectorAll('.srg__card'), function (c) { c.classList.remove('is-out'); restart(c, 'sr-skid'); });
      }
      if (oldP && !RM && !opts.instant) {
        each(oldP.querySelectorAll('.srg__card'), function (c) { c.classList.remove('sr-skid'); c.classList.add('is-out'); });
        setTimeout(swap, 220);
      } else { swap(); }
      centerTab(i);
    }

    function stop() { playing = false; clearInterval(timer); root.classList.remove('is-playing', 'is-paused'); }
    function tick() { show((cur + 1) % tabs.length); }
    function play() {
      if (RM || root.getAttribute('data-autoplay') !== 'true' || tabs.length < 2) return;
      playing = true;
      root.classList.remove('is-playing');
      void root.offsetWidth;
      root.classList.add('is-playing');
      clearInterval(timer);
      timer = setInterval(tick, dur);
    }
    function pause() { if (!playing) return; clearInterval(timer); root.classList.add('is-paused'); }
    function resume() {
      if (!playing) return;
      root.classList.remove('is-paused');
      var bar = tabs[cur] && tabs[cur].querySelector('.srg__tabbar');
      if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      clearInterval(timer);
      timer = setInterval(tick, dur);
    }

    function choose(i) {
      stop();
      show(i);
      store('sr-vehicle', tabs[i].getAttribute('data-key'));
    }

    each(tabs, function (t, k) { t.addEventListener('click', function () { choose(k); }); });
    if (tablist) tablist.addEventListener('keydown', function (e) {
      var n = null, last = tabs.length - 1;
      if (e.key === 'ArrowRight') n = cur >= last ? 0 : cur + 1;
      else if (e.key === 'ArrowLeft') n = cur <= 0 ? last : cur - 1;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = last;
      if (n === null) return;
      e.preventDefault();
      choose(n);
      tabs[n].focus();
    });
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) resume(); });

    var saved = store('sr-vehicle'), start = 0, found = false;
    each(tabs, function (t, k) { if (saved && t.getAttribute('data-key') === saved) { start = k; found = true; } });
    show(start, { instant: true });
    if (!found) play();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) resume(); else pause(); });
      }).observe(root);
    }

    document.addEventListener('shopify:block:select', function (e) {
      if (!root.contains(e.target)) return;
      each(tabs, function (t, k) { if (t.getAttribute('data-block-id') === e.detail.blockId) { stop(); show(k, { instant: true }); } });
    });
  }

  /* ---------- count up ---------- */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-sr-count')) || 0;
    if (RM) { el.textContent = target.toLocaleString('en-AU'); return; }
    var t0 = null;
    function step(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / 1600);
      el.textContent = Math.round(target * (1 - Math.pow(1 - k, 3))).toLocaleString('en-AU');
      if (k < 1) requestAnimationFrame(step);
    }
    el.textContent = '0';
    requestAnimationFrame(step);
  }

  /* ---------- reveal ---------- */
  function reveal(el) {
    if (el.classList.contains('srg__card')) { el.classList.add('sr-skid'); return; }
    el.classList.add('is-in');
    each(el.querySelectorAll('[data-sr-count]'), countUp);
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      reveal(en.target);
    });
  }, { threshold: 0.15 }) : null;

  function initReveal(scope) {
    each(scope.querySelectorAll('.sr-reveal, .srb .srg__card'), function (el) {
      if (el.__srSeen) return;
      el.__srSeen = true;
      if (io && !RM) io.observe(el); else reveal(el);
    });
  }

  function init(scope) {
    scope = scope || document;
    each(scope.querySelectorAll('[data-sr-garage]'), initGarage);
    initReveal(scope);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var b = e.target.closest('[data-sr-add]');
    if (b) { e.preventDefault(); addToCart(b); return; }
    var atc = e.target.closest('.product-form__submit, #sticky-cta .button');
    if (atc && !RM) restart(atc, 'sr-rev');
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.SRSections = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
